// extracted by mini-css-extract-plugin
export var footer = "_na-0";
export var inherit = "_na-1";
export var input = "_na-2";
export var modalContent = "_na-3";
export var quillEditor = "_na-4";
export var subtitle = "_na-5";